import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        const splitUrl = url.split('?');
        return super.parse(splitUrl[0].toLowerCase().concat(splitUrl.length > 1 ? '?' + splitUrl[1] : ''));
    }
}